type Section = { id: string; title: string }

// Source/config shape: subsections are keyed so callers can reference specific entries by name.
export type SectionList = Record<string, Section & { subSections?: Record<string, Section> }>

// Render shape for SectionNav: subsections are flattened and optional because some nav items have no children.
export type NavigationSection = Section & { subSections?: Section[] }

export const applicationSections = {
  commitmentDetails: {
    id: 'commitment-details',
    title: 'Detaljer',
    subSections: {
      overview: { id: 'commitment-details-overview', title: 'Översikt' },
    },
  },
  loanAgreements: {
    id: 'loan-agreements',
    title: 'Lånehandlingar',
    subSections: {},
  },
  depositLoanAgreements: {
    id: 'deposit-loan-agreements',
    title: 'Lånehandlingar för handpenningslån',
    subSections: {},
  },
  loan: {
    id: 'loan',
    title: 'Lånebelopp',
    subSections: {
      overview: { id: 'loan-overview', title: 'Översikt' },
      amortizationProof: { id: 'loan-amortization-proof', title: 'Amorteringsunderlag' },
      parties: { id: 'loan-parties', title: 'Parter' },
      topupPurpose: { id: 'loan-topup-purpose', title: 'Syfte med utökning' },
    },
  },
  cashContribution: {
    id: 'kontantinsats',
    title: 'Kontantinsats',
    subSections: {
      cashContribution: { id: 'kontantinsats-cash-contribution', title: 'Beräkning av kontantinsats' },
      moneySource: { id: 'kontantinsats-money-source', title: 'Pengarnas ursprung' },
      bridgeAndDepositLoans: { id: 'kontantinsats-bridge-deposit-loans', title: 'Brygg- och handpenningslån' },
    },
  },
  repaymentCapacity: {
    id: 'repayment-capacity',
    title: 'Återbetalningsförmåga',
    subSections: {
      applicants: { id: 'repayment-capacity-applicants', title: 'Sökande' },
      documents: { id: 'repayment-capacity-documents', title: 'Dokument' },
    },
  },
  property: {
    id: 'property',
    title: 'Bostaden',
    subSections: {
      details: { id: 'property-details', title: 'Uppgifter om bostaden' },
      valuations: { id: 'property-valuations', title: 'Värderingar' },
      insurance: { id: 'property-insurance', title: 'Försäkring' },
      titleDeed: { id: 'property-title-deed', title: 'Lagfart' },
      housingAssociation: { id: 'property-housing-association', title: 'Bostadsrättsförening' },
    },
  },
  mortgageDeeds: {
    id: 'mortgage-deeds',
    title: 'Pantbrev',
    subSections: {},
  },
  payout: {
    id: 'payout',
    title: 'Utbetalning',
    subSections: {
      date: { id: 'payout-date', title: 'Utbetalningsdatum' },
      details: { id: 'payout-details', title: 'Utbetalningsdetaljer' },
    },
  },
  loanParts: {
    id: 'loan-parts',
    title: 'Lånedelar',
    subSections: {
      loanParts: { id: 'loan-parts-loans', title: 'Lånedelar' },
      paymentDetails: { id: 'loan-parts-payment-details', title: 'Betalningsdetaljer' },
    },
  },
} satisfies SectionList

export type ApplicationSections = typeof applicationSections
